import * as React from 'react';
import Box from '@mui/material/Box';
import Paper from '@mui/material/Paper';
import Stack from '@mui/material/Stack';
import Avatar from '@mui/material/Avatar';
import Typography from '@mui/material/Typography';
import Checkbox from '@mui/material/Checkbox';
import Button from '@mui/material/Button';
import FormLabel from '@mui/material/FormLabel';
import FormControl from '@mui/material/FormControl';
import FormControlLabel from '@mui/material/FormControlLabel';
import Link from '@mui/material/Link';
import OutlinedInput from '@mui/material/OutlinedInput';
import InputAdornment from '@mui/material/InputAdornment';
import IconButton from '@mui/material/IconButton';
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';
import Alert from '@mui/material/Alert';
import CircularProgress from '@mui/material/CircularProgress';
import axios from 'axios';
import { ThemeProvider } from '@mui/material/styles';

import { isMobile, changedToMobileOrDesktop } from './nuiCommon/nuiDeviceDetector';
import text, {taxFormUrl, language, jurisdictionAlpha2} from "./nuiCommon/nuiText";
import {htmlA, htmlButton} from './nuiCommon/nuiHtmlBasics';
import NuiPromptDialog from './nuiCommon/nuiPromptDialog';
import NuiOAuthButtons from './nuiCommon/nuiOAuthButtons';
import NuiRegisterRobotax from './nuiRegisterRobotax';
import {robotaxmakerTheme} from './nuiCommon/nuiRobotaxmakerTheme';
import {isFrameInSite,
        sendHeartBeatNotification,
        sendResizeNotification,
        addMessageListener} from './nuiCommon/nuiFrameLib';

export default class NuiLoginRobotax extends React.Component {
  checkLogin = document.getElementById('checkLogin').innerHTML === 'true';

  constructor(props) {
    super(props);
    this.submitLogin = this.submitLogin.bind(this);
    this.gotoRegister = this.gotoRegister.bind(this);
    this.gotoLogin = this.gotoLogin.bind(this);
    this.blurLogin();
  }

  blurLogin() {
    if (this.checkLogin) {
      document.addEventListener('DOMContentLoaded', function() {
        let root = document.getElementById("userDataBox").children[0];
        let toBlur = root.children[0];
        toBlur.style.filter = "blur(3px)";
        toBlur.style.userSelect = "none";
        toBlur.style.pointerEvents = "none";

        const msg = (text, auth, authInf) =>
              `<span>${text} ${htmlA({text: auth,
                                      link: taxFormUrl('es.robotaxmaker.com'),
                                      target: "_parent"})}.
                 <p>
                   ${htmlButton({text: authInf,
                                 link: taxFormUrl('es.robotaxmaker.com'),
                                 target: "_parent"})}
                 </p>
               </span>`;
        let notifyDiv = document.createElement('div');
        notifyDiv.innerHTML = text(
          {"ru": msg(('Пользователь успешно авторизован. ' +
                      'Для генерации декларации перейдите к'),
                     'расчету налогов',
                     'Расчет налогов'),
           "ua": msg(('Користувач успішно авторизований. ' +
                      'Для створення декларації пройдіть'),
                     'розрахунку податків',
                     'Розрахунок податків'),
           "en": msg(('The user has been successfully authorized. ' +
                      'To generate a declaration, go to'),
                     'tax calculation',
                     'Tax calculation'),
           "es": msg(('El usuario ha sido autorizado exitosamente. ' +
                      'Para generar una declaración, vaya a'),
                     'cálculo de impuestos',
                     'Cálculo de impuestos')});
        notifyDiv.style.position = "absolute";
        notifyDiv.style.top = "50%";
        notifyDiv.style.left = "50%";
        notifyDiv.style.transform = "translate(-50%, -50%)";
        notifyDiv.style.textAlign = "center";
        notifyDiv.style.fontSize = "large";
        root.style.position = "relative";
        root.appendChild(notifyDiv);
      });
    }
  }

  state = {
    activeForm: 'login', // 'login' or 'register'

    showRegisterInfoDialog: false,
    inProgress: false,
    loginFailed: false,
    // Итог сброса пароля: null, 'sent' или 'failed'.
    resetPassword: null,
    resetPasswordError: '',
    // Причина неудачи соц-входа; null - показывать нечего (в том числе когда
    // пользователь сам закрыл окно провайдера).
    oauthError: null,
    login: '',
    password: '',
    email: '',
    rememberMe: false,
    showPassword: false,
    hideSelf: false,
    lastWidth: document.documentElement.clientWidth
  }

  iFrameName = "iFrameLoginRobotaxmaker"

  // create an Observer instance
  resizeObserver = new ResizeObserver(entries =>
    sendResizeNotification(this.iFrameName,
                           entries[0].target.clientHeight))

  componentDidMount() {
    // start observing a DOM node
    this.resizeObserver.observe(document.body);
    addMessageListener({iFrameName: this.iFrameName,
                        self: this});
    sendHeartBeatNotification(this.iFrameName);
    window.addEventListener("resize", (event) => {
      const lastWidth = this.state.lastWidth;
      const currentWidth = document.documentElement.clientWidth;
      this.setState({
        lastWidth: currentWidth
      }, () => {
        if (changedToMobileOrDesktop(lastWidth, currentWidth)) {
          this.forceUpdate();
          this.blurLogin();
        }
      });
    });
    this.blurLogin();
  }

  handleChange = name => event => {
    this.setState({
      [name]: event.target.value,
    });
  };

  handleChangeBoolean = name => event => {
    this.setState({
      [name]: event.target.checked
    });
  };

  handleForgetPasswordDialog = event => {
    if (event != null) {
      event.preventDefault();
    }
    this.setState({ showRegisterInfoDialog: true });
  };

  handleResetPasswordByEmail = value => {
    this.setState({ showRegisterInfoDialog: false });
    if (value === 'ok') {
      this.setState({ inProgress: true, loginFailed: false, resetPassword: null });
      const config = { headers: { 'Content-Type': 'application/json',
                                  'X-Requested-With': 'HttpRequest',
                                  'Csrf-Token': 'nocheck'},
                       timeout: 0};
      const form = new FormData();
      form.append(['login'], this.state.login);
      form.append(['email'], this.state.email);
      axios.post("/resetPassword", form, config)
        .then( (response) => {
          this.setState({ inProgress: false, resetPassword: 'sent' });
        })
        .catch( (error) => {
          // Текст ошибки сервер присылает, когда логин и адрес верны, но
          // письмо не ушло; без него остаётся общий совет проверить их.
          this.setState({ inProgress: false,
                          resetPassword: 'failed',
                          resetPasswordError: error.response?.data?.error || '' });
        });
    }
  };

  gotoTaxForm() {
    this.setState({ hideSelf: true });
    this.forceUpdate();
    window.parent.location.replace(taxFormUrl());
  }

  gotoRegister(event) {
    if (event != null) {
      event.preventDefault();
    }
    this.setState({ activeForm: 'register' });
    this.forceUpdate();
  }

  gotoLogin(event) {
    if (event != null) {
      event.preventDefault();
    }
    this.setState({ activeForm: 'login' });
    this.forceUpdate();
  }

  submitLogin(event) {
    if (event != null) {
      event.preventDefault();
    }
    this.setState({ inProgress: true, resetPassword: null });
    const config = { headers: { 'Content-Type': 'application/json',
                                'X-Requested-With': 'HttpRequest',
                                'Csrf-Token': 'nocheck'},
                     timeout: 0};
    const data = new FormData();
    data.append('login', this.state['login']);
    data.append('password', this.state['password']);
    data.append('rememberMe', this.state['rememberMe']);
    data.append('serviceName', 'robotaxmaker.com');
    axios.post("/login", data, config)
      .then( (response) => {
        if (response.status === 200) {
          this.setState({ loginFailed: false });
          if (this.props.callback != undefined) {
            this.props.callback();
          } else {
            this.gotoTaxForm();
          }
        } else {
          this.setState({ loginFailed: true });
        }
        this.setState({ inProgress: false });
      })
      .catch( (error) => {
        this.setState({ inProgress: false });
        this.setState({ loginFailed: true });
      });
  };

  handleOAuthStart = () => {
    this.setState({ inProgress: true, loginFailed: false, oauthError: null });
  };

  // Сессия уже выдана и кука стоит - дальше ровно то же, что после парольного
  // входа.
  handleOAuthSuccess = () => {
    this.setState({ inProgress: false });
    if (this.props.callback != undefined) {
      this.props.callback();
    } else {
      this.gotoTaxForm();
    }
  };

  handleOAuthError = (reason) => {
    this.setState({
      inProgress: false,
      oauthError: (reason === 'cancelled') ? null : reason
    });
  };

  handleClickShowPassword = () => {
    this.setState({ showPassword: !this.state.showPassword });
  };

  handleMouseDownPassword = (event) => {
    event.preventDefault();
  };

  render() {
    return (
      <ThemeProvider theme={robotaxmakerTheme}>
        {this.state.activeForm == 'register'
         ? <NuiRegisterRobotax
             gotoLogin={this.gotoLogin}/>
         : !this.state.inProgress
         ? <Box
             display={this.state.hideSelf ? "none" : "flex"}
             justifyContent="center"
             alignItems="center">
             <Box id="userDataBox"
                  sx={isMobile()
                      ? {width: "100%"}
                      : {width: 500,
                         mt: 2}}>
               <Paper sx={{ width: 1 }}>
                 <Stack spacing={1}>
                   <Box
                     sx={{pt: 8}}
                     display="flex"
                     justifyContent="center"
                     alignItems="center">
                     <Avatar sx={{ bgcolor: robotaxmakerTheme.palette.primary.main }}>
                       <img src="/images/robotaxmaker_logo_white.svg"
                            height='30px'
                            width='30px'
                            alt='logo'/>
                     </Avatar>
                   </Box>
                   <Box
                     sx={{pt: 0.5}}
                     display="flex"
                     justifyContent="center"
                     alignItems="center">
                     <Typography component="h1" variant="h5">
                       {text({"ru": "Войти",
                              "ua": "Увійдіть",
                              "en": "Sign in",
                              "es": "Iniciar sesión"})}
                     </Typography>
                   </Box>
                   <FormControl
                     sx={{pt: 0.5, pl: 4, pr: 4}}>
                     {this.state.loginFailed
                      ? <Box sx={{pb: 2}}>
                          <Alert severity="error">
                            {text({"ru": "Ошибка аутентификации. Проверьте логин и пароль.",
                                   "ua": "Не вдалося пройти автентифікацію. Перевірте свій логін і пароль.",
                                   "en": "Authentication failed. Check your login and password.",
                                   "es": "La autenticación falló. Verifique su nombre de usuario y contraseña."})}
                          </Alert>
                        </Box>
                      : ""}
                     {this.state.resetPassword === 'sent'
                      ? <Box sx={{pb: 2}}>
                          <Alert severity="success">
                            {text({"ru": `Новый пароль отправлен на ${this.state.email.trim()}. ` +
                                   `Если письма нет во входящих, проверьте папку "Спам".`,
                                   "ua": `Новий пароль надіслано на ${this.state.email.trim()}. ` +
                                   `Якщо листа немає у вхідних, перевірте папку "Спам".`,
                                   "en": `A new password has been sent to ${this.state.email.trim()}. ` +
                                   `If it is not in your inbox, check the spam folder.`,
                                   "es": `Se ha enviado una nueva contraseña a ${this.state.email.trim()}. ` +
                                   `Si no está en la bandeja de entrada, revise la carpeta de spam.`})}
                          </Alert>
                        </Box>
                      : this.state.resetPassword === 'failed'
                      ? <Box sx={{pb: 2}}>
                          <Alert severity="error">
                            {this.state.resetPasswordError ||
                             text({"ru": "Невозможно сбросить пароль. Проверьте введенный логин и Email.",
                                   "ua": "Неможливо скинути пароль. Перевірте введений логін та електронну пошту.",
                                   "en": "Password reset error. Check the entered login and email.",
                                   "es": "Error de restablecimiento de contraseña. Verifique el inicio de sesión y el correo electrónico ingresados."})}
                          </Alert>
                        </Box>
                      : ""}
                     <FormLabel htmlFor="loginL">
                       {text({"ru": "Логин",
                              "ua": "Логін",
                              "en": "Login",
                              "es": "Acceso"})}
                     </FormLabel>
                     <OutlinedInput
                       id="loginL"
                       type="login"
                       name="login"
                       autoComplete="email"
                       autoFocus
                       required
                       fullWidth
                       value={this.state.login}
                       onChange={this.handleChange('login')}>
                     </OutlinedInput>
                   </FormControl>
                   <FormControl sx={{pl: 4, pr: 4, pt: 1}}>
                     <FormLabel htmlFor="passwordL">
                       {text({"ru": "Пароль",
                              "ua": "Пароль",
                              "en": "Password",
                              "es": "Contraseña"})}
                     </FormLabel>
                     <OutlinedInput
                       id="passwordL"
                       margin="normal"
                       required
                       fullWidth
                       name="password"
                       type={this.state.showPassword ? 'text' : 'password'}
                       value={this.state.password}
                       onChange={this.handleChange('password')}
                       autoComplete="current-password"
                       endAdornment={
                         <InputAdornment position="end">
                           <IconButton
                             aria-label="toggle password visibility"
                             onClick={this.handleClickShowPassword}
                             onMouseDown={this.handleMouseDownPassword}>
                             {this.state.showPassword
                              ? <Visibility />
                              : <VisibilityOff />}
                           </IconButton>
                         </InputAdornment>}/>
                   </FormControl>
                   <FormControlLabel sx={{pl: 2.5}}
                                     control={<Checkbox color="primary" />}
                                     label={text({"ru": "Запомнить меня",
                                                  "ua": "Пам'ятай мене",
                                                  "en": "Remember me",
                                                  "es": "Acuérdate de mí"})}
                                     value={this.state.rememberMe}
                                     onChange={this.handleChangeBoolean('rememberMe')}>
                   </FormControlLabel>
                   <Box sx={{pl: 4, pr: 4, pt: 2}}>
                     <Button
                       type="submit"
                       fullWidth
                       variant="contained"
                       color="primary"
                       onClick={this.submitLogin}>
                       {text({"ru": "Войти",
                              "ua": "Увійдіть",
                              "en": "Sign in",
                              "es": "Iniciar sesión"})}
                     </Button>
                   </Box>
                   {this.state.oauthError != null
                    ? <Box sx={{pl: 4, pr: 4, pt: 2}}>
                        <Alert severity="error">
                          {this.state.oauthError === 'popup_blocked'
                           ? text({"ru": "Браузер заблокировал всплывающее окно. Разрешите его для этого сайта и попробуйте снова.",
                                   "ua": "Браузер заблокував спливаюче вікно. Дозвольте його для цього сайту та спробуйте ще раз.",
                                   "en": "The browser blocked the popup window. Allow popups for this site and try again.",
                                   "es": "El navegador bloqueó la ventana emergente. Permítala para este sitio e inténtelo de nuevo."})
                           : text({"ru": "Не удалось войти через соцсеть. Попробуйте ещё раз или войдите по паролю.",
                                   "ua": "Не вдалося увійти через соцмережу. Спробуйте ще раз або увійдіть за паролем.",
                                   "en": "Social sign-in failed. Try again or sign in with your password.",
                                   "es": "No se pudo iniciar sesión con la red social. Inténtelo de nuevo o use su contraseña."})}
                        </Alert>
                      </Box>
                    : ""}
                   <NuiOAuthButtons
                     lang={language}
                     residenceCountry={jurisdictionAlpha2()}
                     onStart={this.handleOAuthStart}
                     onSuccess={this.handleOAuthSuccess}
                     onError={this.handleOAuthError}/>
                   <Box sx={{pl: 4, pr: 4, pt: 2, pb: 3,
                             display: "flow"}}>
                     <Link component="button" variant="body2"
                           sx={{float: "left"}}
                           onClick={this.handleForgetPasswordDialog}>
                       {text({"ru": "Забыли пароль?",
                              "ua": "Забули пароль?",
                              "en": "Forgot your password?",
                              "es": "¿Olvidaste tu contraseña?"})}
                     </Link>
                     <Link component="button" variant="body2"
                           sx={{float: "right"}}
                           onClick={this.gotoRegister}>
                       {text({"ru": "Регистрация",
                              "ua": "Зареєструватися",
                              "en": "Sign up",
                              "es": "Inscríbete"})}
                     </Link>
                   </Box>
                 </Stack>
               </Paper>
             </Box>
           </Box>
         : <Box display='flex'
                justifyContent="center"
                alignItems="center"
                sx={{pt: (isFrameInSite() ? 0 : 30)}}>
             <CircularProgress size={90}/>
           </Box>}
        <NuiPromptDialog
          parent={this}
          open={this.state.showRegisterInfoDialog}
          onClose={this.handleResetPasswordByEmail}
          title={text({"ru": "Почта для нового пароля",
                       "ua": "Електронна пошта для отримання нового пароля",
                       "en": "Email for new password",
                       "es": "Correo electrónico para nueva contraseña"})}
          message={text({"ru": "Укажите Email адрес, на который " +
                         "необходимо отправить новый пароль.",
                         "ua": "Введіть адресу електронної пошти, на " +
                         "яку ви хочете надіслати новий пароль.",
                         "en": "Enter the email address to which " +
                         "you want to send a new password.",
                         "es": "Introduzca la dirección de correo electrónico " +
                         "a la que desea enviar una nueva contraseña."})}
          stateName="email"
          label='Email'
          type='email'
          stateName2="login"
          label2={text({"ru": "Логин",
                        "ua": "Логін",
                        "en": "Login",
                        "es": "Acceso"})}
          type2='text'>
        </NuiPromptDialog>
      </ThemeProvider>
    );
  }
}
